import Quoter from './Quoter';

export default Quoter;
